// rail tooltips.
import { $, narrow } from './core.ts';

export function initRailTips(): void {
  const side = $('.ds-side');
  if (!side) return;
  let tip: HTMLDivElement | null = null;
  const hide = (): void => {
    tip?.remove();
    tip = null;
  };
  const target = (e: Event): HTMLElement | null | undefined =>
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- an event target can be the document or a text node, which have no closest/matches
    (e.target as Element).closest?.<HTMLElement>('.ds-nav > a, .ds-nav > .ds-ng > .ds-np');
  const show = (el: HTMLElement): void => {
    hide();
    if (
      !$('.ds-app')?.classList.contains('ds-rail') ||
      narrow(860) ||
      !el.dataset.tip ||
      el.getAttribute('aria-expanded') === 'true'
    )
      return;
    const r = el.getBoundingClientRect();
    tip = Object.assign(document.createElement('div'), { className: 'ds-tip', textContent: el.dataset.tip });
    tip.style.right = innerWidth - r.left + 10 + 'px';
    tip.style.top = r.top + r.height / 2 + 'px';
    document.body.appendChild(tip);
  };
  side.addEventListener('mouseover', e => {
    const el = target(e);
    if (el && !el.contains(e.relatedTarget as Node | null)) show(el);
  });
  side.addEventListener('mouseout', e => {
    const el = target(e);
    if (el && !el.contains(e.relatedTarget as Node | null)) hide();
  });
  side.addEventListener('focusin', e => {
    const el = target(e);
    if (el) show(el);
  });
  side.addEventListener('focusout', hide);
  side.addEventListener('scroll', hide, { passive: true });
  side.addEventListener('click', hide);
}
